const updates = [
  { date: '07-28', title: '《社内恋爱法则》第128话更新', tag: '韩漫', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-28', title: '《重生之都市仙尊》第205话更新', tag: '国漫', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-27', title: '《极道千金》第89话更新', tag: '韩漫', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-27', title: '《咒术学院》第156话更新', tag: '日漫', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-26', title: '《总裁的秘密情人》第67话更新', tag: '韩漫', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-26', title: '《斗破苍穹之巅峰》第312话更新', tag: '国漫', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-25', title: '《异世界料理人》第44话更新', tag: '日漫', tagColor: 'bg-secondary-100 text-secondary-700' },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">最近更新</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            热门漫画每日同步更新，追更快人一步
          </p>
        </div>

        <div className="relative pl-8 border-l-2 border-background-300">
          {updates.map((item, idx) => (
            <div key={idx} className="relative mb-6 last:mb-0">
              <div className="absolute -left-[calc(2rem+5px)] top-1 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
              <div className="flex flex-wrap items-start gap-2 md:gap-3">
                <span className="text-xs font-medium text-foreground-500 whitespace-nowrap mt-0.5">{item.date}</span>
                <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${item.tagColor}`}>{item.tag}</span>
                <span className="text-sm md:text-base text-foreground-800 font-medium">{item.title}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#index"
            onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="inline-flex items-center text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer whitespace-nowrap transition-colors"
          >
            查看更多更新
            <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>
      </div>
    </section>
  );
}